import React, { useMemo } from 'react';

import { Point3D } from '@paragon/three-shared';

const itemSize = 3;

interface Props {
  readonly lineStart: Point3D;
  readonly lineEnd: Point3D;
  readonly color: number;
  readonly thickness: number;
}

export default function MeshLine(props: Props) {
  const vertices = useMemo(
    () =>
      new Float32Array([
        props.lineStart.x,
        props.lineStart.y,
        props.lineStart.z,
        props.lineEnd.x,
        props.lineEnd.y,
        props.lineEnd.z,
      ]),
    [props.lineEnd.x, props.lineEnd.y, props.lineEnd.z, props.lineStart.x, props.lineStart.y, props.lineStart.z],
  );

  return (
    <line>
      <bufferGeometry attach="geometry">
        <bufferAttribute attach="attributes-position" args={[vertices, itemSize]} count={vertices.length / itemSize} />
      </bufferGeometry>
      <lineBasicMaterial attach="material" color={props.color} linewidth={props.thickness} />
    </line>
  );
}
